export default __webpack_public_path__ + "static/media/icon-ui-washer.31fa2365.svg";